module.exports = __webpack_public_path__ + "static/media/vehicle.54951654.svg";